import API from '../utils/api'

const solutionApiBaseUrl = '/api/solution';
const contentUrl = solutionApiBaseUrl + '/GetCategoryOrder/';


export function findSolutions(params) {
    return API.get(contentUrl, {
        params: params
    }).then(response => {
        return response
    })
}